// Sends the product page's star rating down to the reviews widget.
//
// The widget is an app block, so there is no id of ours to anchor to and no guarantee it
// has mounted by the time someone clicks. Both are handled by resolving the target at
// click time and falling back through a few selectors.
(() => {
  const REVIEW_SELECTORS = [
    '.okeReviews',
    '[id*="okendo_reviews_widget"]',
    '[id*="okendo"]',
    '[class*="oke-w"]',
  ];

  const findReviews = () => {
    for (const selector of REVIEW_SELECTORS) {
      const found = document.querySelector(selector);

      if (found && found.getBoundingClientRect().height > 0) {
        return found;
      }
    }

    return null;
  };

  const headerOffset = () => {
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    return parseFloat(raw) || 0;
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-scroll-to-reviews]');

    if (!trigger) {
      return;
    }

    const reviews = findReviews();

    if (!reviews) {
      return;
    }

    event.preventDefault();

    // The section heading sits above the widget, so aim at the section to bring it along.
    // Unless the widget shares a section with the stars, which would scroll nowhere useful.
    const section = reviews.closest('.shopify-section');
    const target = section && !section.contains(trigger) ? section : reviews;

    // A little breathing room under the sticky header, which otherwise covers the heading.
    const top = target.getBoundingClientRect().top + window.scrollY - headerOffset() - 24;

    window.scrollTo({ top, behavior: 'smooth' });
  });
})();
